import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
export function ChallengeSection() {
  return <section className="bg-navy px-4 py-16 text-white md:py-24" data-id="element-141" data-mp="1nq886a40u9is">
      <div className="mx-auto max-w-3xl" data-id="element-142" data-mp="1sjsw19bwhn49">
        <SectionHeading onDark eyebrow="The real challenge isn’t always your knowledge" title="It’s knowing how to organize what you find." data-id="element-143" data-mp="1skuisb2a3y1t" />
        <div className="mt-8 space-y-5 text-lg leading-relaxed text-white/85" data-id="element-144" data-mp="zvnawlgxpw3w">
          <p data-id="element-145" data-mp="14u8aciod4bra">Shoulder pain can present in many different ways.</p>
          <p data-id="element-146" data-mp="19sjjssaqwk8z">
            Some patients describe pain during overhead activities. Others report restricted movement, weakness,
            discomfort during sleep, symptoms following trauma, or difficulties performing everyday tasks.
          </p>
          <p className="font-semibold text-white" data-id="element-147" data-mp="2l6x4xpe46llb">Similar symptoms can occur in different clinical presentations.</p>
          <p data-id="element-148" data-mp="2q8mibbot7bck">A useful assessment involves more than selecting a few physical tests.</p>
          <p data-id="element-149" data-mp="19freiory6eiw">
            You need to gather relevant information, understand the patient’s presentation, consider alternative
            explanations, recognize uncertainty, and identify situations that may require additional medical
            evaluation.
          </p>
          <p className="border-l-4 border-gold pl-4 text-white" data-id="element-150" data-mp="vfglbf360nuk">
            Individual examination findings have limitations and need to be interpreted alongside the patient’s
            history and the rest of the clinical examination.
          </p>
          <p data-id="element-151" data-mp="lovre4yfs7hz">That’s why I wanted this collection to focus on the assessment process itself.</p>
          <p data-id="element-152" data-mp="gp99hi7ny32u">
            The Shoulder Assessment Blueprint™ brings together educational references, practical worksheets,
            examination resources, and case-based exercises to help you review the different components of your
            evaluation in one place.
          </p>
          <p data-id="element-153" data-mp="2txhvjot0sq5">
            You’ll have a structured resource to revisit when preparing for an assessment, reviewing a case, or
            refining your documentation process.
          </p>
        </div>
        <div className="mt-10" data-id="element-154" data-mp="3u6mmyhgbjtit">
          <CtaButton onDark label="Bring more structure to your shoulder assessments" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-155" data-mp="3fbouzpp31629" />
        </div>
      </div>
    </section>;
}